export class NewPlanOption {
    salesDocType: string;
    brand: string;
    maxKilometers: number;
    years: number;
    planType: string;
    price: number;

    planStartKM: number;
    planStartDate: Date;
    planEndDate: Date;
    isCustomPlan: boolean;

    constructor() {
        this.isCustomPlan = false;
    }
}
